import $ from 'jquery';

const NOTICE_KEY = 'new-account-notice-dismissed';

const notice = $('[data-notice-key="new-account-notice"]');

if (notice.length) {
  if (localStorage.getItem(NOTICE_KEY)) {
    notice.remove();
  } else {
    notice.find('[data-notice-dismiss]').on('click', () => {
      localStorage.setItem(NOTICE_KEY, '1');
      notice.remove();
    });
  }
}
